/**
 * English - Validation messages translations
 */
export const validation = {
  required: '{field} is required',
  email: 'Please enter a valid email address',
  minLength: '{field} must be at least {min} characters',
  maxLength: '{field} must be at most {max} characters',
  pattern: '{field} format is invalid',
  passwordMatch: 'Passwords do not match',
  phoneFormat: 'Please enter a valid phone number',
  phoneInvalid: 'Please enter a valid phone number',
  dateFormat: 'Please enter a valid date',
  dateInvalid: 'Please enter a valid date',
  numberMin: '{field} must be at least {min}',
  numberMax: '{field} must be at most {max}',
  numberInvalid: 'Please enter a valid number',
  positiveNumber: 'Please enter a positive number',
  invalidFormat: 'Invalid format',
  tooShort: 'Too short',
  tooLong: 'Too long',
  fileSize: 'File size must be less than {max}',
  fileType: 'File type not allowed',
  missingFields: 'Please complete the following required fields',
  errors: 'Validation errors',
} as const;